export const routes = {
  list: (page: number, limit: number) => `/parent/notifications?page=${page}&limit=${limit}`,
  unreadCount: () => `/parent/notifications/unread-count`,
};
